import {
  MODAL_SCHEDULE_CRAWL,
  MODAL_SHARE,
  MODAL_UPGRADE_PLAN,
} from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import type { ScheduleDto } from '@octopus-do/octopus-api-client'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { createSwitch } from '@/utils'
import { useDownloadActions } from '../DownloadMenu'

const ExportUpgradeModal = openModal({
  modalType: MODAL_UPGRADE_PLAN,
  modalProps: {
    planType: 'pro',
  },
})

const ShareModal = openModal({
  modalType: MODAL_SHARE,
  modalProps: { activeTab: Tab.Access },
})

interface Params {
  onRecrawl: () => void
  onScheduled: () => void
  schedule: ScheduleDto | null
}

export const useSettings = ({ onRecrawl, onScheduled, schedule }: Params) => {
  const dispatch = useDispatch()
  const downloadSwitcher = useDownloadActions('download')

  const switcher = createSwitch()
    .case(['refresh'], () => onRecrawl())
    .case(['schedule'], () =>
      dispatch(
        openModal({
          modalType: MODAL_SCHEDULE_CRAWL,
          modalProps: { initial: schedule, onSaved: onScheduled },
        })
      )
    )
    .case(['upgrade'], () => {
      sendGtmEvent(GtmTriggerName.REPORT_SCHEDULE_UPGRADE)
      dispatch(ExportUpgradeModal)
    })
    .case(['share'], () => dispatch(ShareModal))
    .append(downloadSwitcher)

  const onClick = (keys: string[]) => switcher.run(keys)

  return { onClick }
}
